import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
import { PALETTE_SCHEMAS } from "@/lib/constants";

export const typeDef = gql`
  type PaletteObject {
    id: Int
    type: String
    meta: Meta
    advertising: Advert
  }

  type Palette {
    palette_id: ID!
    name: String
    id_key: String
    header: String
    description: String
    schema_id: Int
    schema: String
    values: JSONObject
  }

  type PaletteObjectConnection {
    data: [PaletteObject]
    pageInfo: PageInfo
  }

  type Query {
    palette(id: Int): Palette
    paletteObjects(id: Int, offset: Int, limit: Int): PaletteObjectConnection
  }
`;

export const resolvers = {
  Query: {
    palette: async (_parent, { id }, { dataSources }) => {
      try {
        return await dataSources.palette.getPalette(id);
      } catch (e) {
        if (
          e?.extensions?.response &&
          e?.extensions?.response?.status !== 404
        ) {
          console.log(e.extensions.response);
        }
        return null;
      }
    },
    paletteObjects: async (_parent, { id, offset, limit }, { dataSources }) => {
      try {
        const result = await dataSources.palette.paletteObjects(
          id,
          offset,
          limit
        );
        return {
          data: result.objects,
          pageInfo: createPageInfo({
            limit,
            offset,
            count: result.total_count,
          }),
        };
      } catch (e) {
        if (
          e?.extensions?.response &&
          e?.extensions?.response?.status !== 404
        ) {
          console.log(e.extensions.response);
        }
        return {
          data: [],
          pageInfo: createPageInfo({ limit, offset, count: 0 }),
        };
      }
    },
  },
  Palette: {
    schema: (palette) => PALETTE_SCHEMAS[palette.schema_id],
  },
};
